import { refreshAccessToken } from "../../services/AuthenticationService";
import { fetchUserInfo } from "../../services/UserService";
import { ActionType } from "../interfaces/Action";


export function authHeader() {

	const token = localStorage.getItem("access_token");

	if (token) {
		return { Authorization: "Bearer " + token,
				 'Access-Control-Allow-Origin': '*'};
	} else {
		return {};
	}
}

export async function getRequestHeader() {
	

	if(new Date(localStorage.getItem("accesstoken_expiry")!) <= new Date())
	{
		// renew access token 
		const data = await refreshAccessToken();
		// handle ping server error on refresh token expiry
		if (data.type === ActionType.FETCH_ACCESS_TOKEN_FAILURE) {
			console.log("refresh token failed!!");
			localStorage.clear();
			const originURL = window.location.origin;
			window.location.href = originURL;
		}

		// Update UserInfo & TECToolAuthorizeToken
		const userData: any = await fetchUserInfo();
		// update global user info 
		if(userData !== null) {
			let global: any = globalThis;
			global.userDetails = userData.payload;
		}
	}

	const token = localStorage.getItem("access_token");

	if (token) {
		return { 
			'Content-Type': 'application/json;charset=utf-8',
			'Authorization': 'Bearer ' + token, 
			'Access-Control-Allow-Origin': '*',
			'Access-Control-Allow-Credentials': true,
			'Access-Control-Allow-Headers': '*',
			'Access-Control-Allow-Methods': 'PUT, POST, GET, DELETE, PATCH, OPTIONS',
			'Access-Control-Max-Age': '600',
		};
	} else {
		return {};
	}
}